import {
  WuiOverlayProvider,
  WuiOverlayRenderer,
  WuiProvider,
  WuiThemeProvider,
  WuiThemeSection,
} from '@jwplayer/wui-react';
import { Router } from 'react-router-dom';

// import { ReactQueryDevtools } from 'react-query-devtools';

import { useCurrentRoute } from '/module/routing/hooks';

import { browserHistory } from './history';

export function DataProviders({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Router history={browserHistory}>{children}</Router>

      {/* {import.meta.env.APP_NODE_ENV === 'development' ? <ReactQueryDevtools /> : null} */}
    </>
  );
}

export function UIProviders({ children }: { children: React.ReactNode }) {
  const route = useCurrentRoute();
  const theme: 'light' | 'dark' = route?.chrome === 'fullscreen' ? 'dark' : 'light';

  return (
    <WuiProvider>
      <WuiThemeProvider
        options={{
          applyBodyClass: true,
          defaultTheme: 'light',
          useOsPreference: false,
        }}
      >
        <WuiOverlayProvider>
          {children}

          {/* Only wrap overlay renderer in a theme section. The application doesn't have full theming support yet. */}
          <WuiThemeSection theme={theme} themed={['fg']}>
            <WuiOverlayRenderer />
          </WuiThemeSection>
        </WuiOverlayProvider>
      </WuiThemeProvider>
    </WuiProvider>
  );
}

/**
 * Gathers all outer-most application providers
 */
export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <DataProviders>
      <UIProviders>{children}</UIProviders>
    </DataProviders>
  );
}
